
import { useState, useEffect } from 'react'
import { Message } from '@/types/chat-types'

export function useChatState() {
  const [messages, setMessages] = useState<Message[]>([])
  const [sessionId, setSessionId] = useState<string>('')

  useEffect(() => {
    // Generate a random session ID if one doesn't exist
    if (!sessionId) {
      setSessionId(`session_${Math.random().toString(36).substring(2, 15)}`)
    }

    // Load messages from localStorage
    const storedHistory = localStorage.getItem('chatHistory')
    if (storedHistory) {
      try {
        const parsedHistory = JSON.parse(storedHistory)
        setMessages(parsedHistory)
      } catch (error) {
        console.error('Error parsing chat history:', error)
      }
    }
  }, [sessionId])

  // Save messages to localStorage whenever they change
  useEffect(() => {
    if (messages.length > 0) {
      localStorage.setItem('chatHistory', JSON.stringify(messages))
    }
  }, [messages])

  return { messages, setMessages, sessionId }
}
